/**
 * Temperature → colour band lookup for the forecast chart's max-temp
 * line. Same abstraction shape as wbgtScale so it can move to a shared
 * config later. Thresholds chosen to align with the 環境省 advisory
 * narrative: 30°C+ is the conversation-trigger temperature in summer.
 */

export type TempBand = {
  min: number;
  max: number;
  color: string;
  label: string;
};

export const TEMP_BANDS: readonly TempBand[] = [
  { min: 35, max: Infinity, color: '#7e0023', label: '猛暑日' },
  { min: 30, max: 35,       color: '#e60012', label: '真夏日' },
  { min: 25, max: 30,       color: '#ef8200', label: '夏日' },
  { min: 15, max: 25,       color: '#1d8eff', label: '快適' },
  { min: -Infinity, max: 15, color: '#3b66c4', label: '涼しい' },
];

export function tempColor(temp: number | null | undefined): string {
  if (temp == null) return '#cbd5e1';
  for (const band of TEMP_BANDS) {
    if (temp >= band.min && temp < band.max) return band.color;
  }
  return '#cbd5e1';
}
